var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-embed h-0 relative",style:({ paddingBottom: _vm.paddingBottom })},[_c('iframe',_vm._b({staticClass:"absolute inset-0 w-full h-full",attrs:{"src":_vm.src}},'iframe',_vm.iframeAttrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }